export default ({ userEmail }) => (
  <div className="newPaybarNotificationEmailSent">
    <span
      className="newPaybarNotice-message"
      dangerouslySetInnerHTML={{ __html: I18n.t('newPaybar.notice.vacancy.emailSent.text', { email: userEmail }) }}>
    </span>
  </div>
)
